module.exports = __webpack_public_path__ + "img/malva.fe849837.jpg";